import styled from 'styled-components';

const ListContainer = styled.div`
width: 100%;
background-color: #fff;
z-index: 20;
overflow-y: scroll;
margin-top:-0.12rem;
.null-list-block {
height: 14rem;
width: 100%;
}
`;

const NotHasMore = styled.div`
width: 100%;
text-align: center;
height: 1.3rem;
font-size: .2rem;
color: #BFBFBF;
padding-top: 0.2rem;
`;

const NoData = styled.div`
display: flex;
flex-direction: column;
align-items: center;
width: 100%;
height: 15rem;
text-align: center;
padding-top: 2rem;
img {
width: 3rem;
height: 3rem;
}
p {
font-family: PingFangSC-Regular;
	font-size: 0.3rem;
	line-height: 0.44rem;
	color: #bfbfbf;
}
`;


export {
  ListContainer,
  NotHasMore,
  NoData,
};
